import { render, staticRenderFns } from "./RgPopup.vue?vue&type=template&id=245ed711&scoped=true&"
import script from "./RgPopup.vue?vue&type=script&lang=js&"
export * from "./RgPopup.vue?vue&type=script&lang=js&"
import style0 from "./RgPopup.vue?vue&type=style&index=0&id=245ed711&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ed711",
  null
  
)

export default component.exports